// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateAttachments_root__87z0v {
  margin-top: 16px;
}

.CertificateAttachments_attachments__O4-Hd {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  min-height: 200px;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL {
  position: relative;
  width: 100%;
  height: 100%;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL .CertificateAttachments_icon__QVBtF {
  color: #333;
  background-color: #eee;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL img {
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL img:hover {
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.9960784314);
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL .CertificateAttachments_closeIcon__D3oVw {
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  right: 0;
  cursor: pointer;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL .CertificateAttachments_closeIcon__D3oVw svg {
  display: none;
  color: red;
  position: absolute;
  background-color: #fff;
  border-radius: 50%;
  top: -12px;
  right: -12px;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL .CertificateAttachments_closeIcon__D3oVw:hover svg, .CertificateAttachments_attachments__O4-Hd .CertificateAttachments_attachment__0YCdo .CertificateAttachments_imgContainer__Ky8mL .CertificateAttachments_closeIcon__D3oVw.CertificateAttachments_remove__1LuE0 svg {
  display: inline;
}
.CertificateAttachments_attachments__O4-Hd .CertificateAttachments_all__21B0A {
  display: flex;
  height: 100px;
}

.CertificateAttachments_dropArea__joKRL {
  background-color: #f2f2f2;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/CertificateAttachments/CertificateAttachments.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AAEF;AADE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGJ;AAFI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAIN;AAHM;EACE,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAKR;AAHM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAKR;AAJQ;EACE,6DAAA;AAMV;AAHM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AAKR;AAJQ;EACE,aAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAMV;AAFU;EACE,eAAA;AAIZ;AAEE;EACE,aAAA;EACA,aAAA;AAAJ;;AAIA;EACE,yBAAA;AADF","sourcesContent":[".root {\r\n  margin-top: 16px;\r\n}\r\n.attachments {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  min-height: 200px;\r\n  .attachment {\r\n    width: 100px;\r\n    height: 100px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    .imgContainer {\r\n      position: relative;\r\n      width: 100%;\r\n      height: 100%;\r\n      .icon {\r\n        color: #333;\r\n        background-color: #eee;\r\n        cursor: pointer;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        text-align: center;\r\n      }\r\n      img {\r\n        max-width: 100%;\r\n        max-height: 100%;\r\n        cursor: pointer;\r\n        &:hover {\r\n          box-shadow: 0px 0px 4px 0px #fffffffe;\r\n        }\r\n      }\r\n      .closeIcon {\r\n        position: absolute;\r\n        width: 16px;\r\n        height: 16px;\r\n        top: 0;\r\n        right: 0;\r\n        cursor: pointer;\r\n        svg {\r\n          display: none;\r\n          color: red;\r\n          position: absolute;\r\n          background-color: #fff;\r\n          border-radius: 50%;\r\n          top: -12px;\r\n          right: -12px;\r\n        }\r\n        &:hover,\r\n        &.remove {\r\n          svg {\r\n            display: inline;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .all {\r\n    display: flex;\r\n    height: 100px;\r\n  }\r\n}\r\n\r\n.dropArea {\r\n  background-color: #f2f2f2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CertificateAttachments_root__87z0v`,
	"attachments": `CertificateAttachments_attachments__O4-Hd`,
	"attachment": `CertificateAttachments_attachment__0YCdo`,
	"imgContainer": `CertificateAttachments_imgContainer__Ky8mL`,
	"icon": `CertificateAttachments_icon__QVBtF`,
	"closeIcon": `CertificateAttachments_closeIcon__D3oVw`,
	"remove": `CertificateAttachments_remove__1LuE0`,
	"all": `CertificateAttachments_all__21B0A`,
	"dropArea": `CertificateAttachments_dropArea__joKRL`
};
export default ___CSS_LOADER_EXPORT___;
